var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video mx-auto"},[_c('div',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"allow":"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":"true","frameborder":"0","src":_vm.videoUrl,"title":_vm.videoTitle}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }